import { LISTING_ATTRIBUTE_SECTIONS } from '../config/listingAttributesModel';

const SECONDARY_LABEL_BY_KEY = (() => {
  const m = new Map();
  for (const section of LISTING_ATTRIBUTE_SECTIONS) {
    for (const f of section.fields || []) {
      m.set(f.key, f.label);
    }
  }
  return m;
})();

function isSecondaryValueActive(v) {
  if (v == null || v === '') return false;
  if (Array.isArray(v) && v.length === 0) return false;
  if (typeof v === 'number' && v === 0) return false;
  return true;
}

function shortFieldLabel(full) {
  if (!full) return '';
  const cut = full.split('/')[0].split('(')[0].trim();
  return cut.length > 28 ? `${cut.slice(0, 26)}…` : cut;
}

function formatSecondaryChip(key, val) {
  const base = shortFieldLabel(SECONDARY_LABEL_BY_KEY.get(key) || key);
  if (val === 'Yes' || val === 'No') {
    return val === 'Yes' ? base : `${base}: No`;
  }
  if (Array.isArray(val)) {
    const joined = val.join(', ');
    return joined.length > 22 ? `${base}: ${joined.slice(0, 20)}…` : `${base}: ${joined}`;
  }
  if (key === 'bedroomsCount' || key === 'bathroomsCount') {
    return `${base} ≥${val}`;
  }
  if (key === 'distanceFromCityKm') {
    return `≤${val} km city`;
  }
  const s = String(val);
  return s.length > 18 ? `${base}: ${s.slice(0, 16)}…` : `${base}: ${s}`;
}

/**
 * Human-readable labels for non-default advanced search filters (primary + secondary).
 * Order: primary (fixed priority), then secondary (stable key order).
 */
export function getAppliedAdvancedFilterLabels(advancedFilters) {
  const out = [];
  if (!advancedFilters) return out;

  const primary = advancedFilters.primary || {};
  const secondary = advancedFilters.secondary || {};

  const budget = primary.budget || 0;
  if (budget > 0) out.push(`Budget ≤₹${budget}K`);

  const minRating = primary.minRating || 0;
  if (minRating > 0) out.push(`Rating ${minRating}+`);

  const wb = primary.waterbody || [];
  if (wb.length > 0) {
    const j = wb.join(', ');
    out.push(j.length > 24 ? `${j.slice(0, 22)}…` : j);
  }

  if (primary.petCharges) {
    let t = `Pet ${primary.petCharges}`;
    if (primary.petCharges === 'Paid' && (primary.petChargesAmount || 0) > 0) {
      t += ` ≤₹${primary.petChargesAmount}K`;
    }
    out.push(t);
  }

  if (primary.dogsInPool) {
    out.push(
      primary.dogsInPool.length > 20 ? `${primary.dogsInPool.slice(0, 18)}…` : primary.dogsInPool
    );
  }

  const trek = primary.trekTrail || [];
  if (trek.length > 0) {
    const j = trek.join(', ');
    out.push(j.length > 28 ? `${j.slice(0, 26)}…` : j);
  }

  if (primary.filterCity && String(primary.filterCity).trim()) {
    const c = String(primary.filterCity).trim();
    out.push(c.length > 18 ? `${c.slice(0, 16)}…` : c);
  }

  if (primary.nearMe && typeof primary.nearMe === 'object') {
    out.push('Near me');
  }

  const secKeys = Object.keys(secondary).sort();
  for (const key of secKeys) {
    const val = secondary[key];
    if (!isSecondaryValueActive(val)) continue;
    out.push(formatSecondaryChip(key, val));
  }

  return out;
}
